import React from "react";

function Footer() {
    return (
        <div className="bg-masters-green">
            <p className="text-sm py-6 masters-label">Copyright &copy; 2024 WalkingFishes</p>
        </div>
    );
};

export default Footer;